import { matchPath, useLocation } from "react-router-dom";

const useIsGeneralMode = () => {
  const { pathname } = useLocation();

  const match = matchPath("/general/*", pathname);

  return !!match;
};

export default useIsGeneralMode;
